import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../../node_modules/swiper/swiper-bundle.min.css";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const ImageSlider = () => {
    const images = [
        {
            src: "./images/ljud/mixerborddark.png",
            heading: "LJUD",
            description: "Vi har ett brett utbud av ljudsystem för uthyrning. Från små aktiva högtalare till större Line Array system. Vi har både analoga och digitala mixerbord, 30-talet olika mikrofoner för tal, sång och instrument, trådlösa mikrofoner och InEar-system.",
        },
        {
            src: "./images/ljus/ledbardark.png",
            heading: "LJUS",
            description: "Ljus till disco, konsert, event eller för att färga någon fasad. Små enkla ljusbord till avancerade ljusbord från bland annat Avolites. Hos oss kan du hyra en enstaka armaturer eller en hel festivalrigg.",
        },
        {
            src: "./images/ljud/djutrustningdark.png",
            heading: "DJ",
            description: "DJ-bänkar från främst Pioneer. Discobelysning i olika storlek, både med inbyggd mikrofon till programeringsbara antingen med DJ controller eller ljusbord",
        },
        {
            src: "./images/rigging/riggingdark.png",
            heading: "TRUSS",
            description: "Inget att hänga i? Lugn, vi har ground support, golvplattor och justerbara ben. Fyrkantstruss, stegtruss och 1-rörstruss i längder från 5 cm till 3 m och mängder med specialdelar.",
        },
        {
            src: "./images/ljud/mikrofon.png",
            heading: "KONSERT",
            description: "Vi kan leverera helhetslösningen till din konsert. Från scen till ljud och ljusriggar. Vi har det som behövs, Linearray, monitorer, högtalare, mixerbord, mikrofoner, Lineboxar, moving heads, ledbars , effekter, gnistregn.",
        },
        {
            src: "./images/teater.png",
            heading: "TEATER",
            description: "Vi har stor erfarenhet av att hyra ut teknik och hjälpa till med konsultation inom tekniska lösningar för teater, då främst Qlab-programering och trussbyggen. Vi kan även leverera ett stort antal trådlösa myggor och headset, Qlab datorer, högtalare m.m. Eller varför inte våra batteridrivna lampor inför premiären?",
        },
        {
            src: "./images/ljud/djutrustning.png",
            heading: "EVENT",
            description: "Företagsevent, mässa, utställning, Gnistregn, konfetti kanoner, Co2, Rökmaskiner, Skummaskiner, UV ljus är några av de effekter vi har på lager och kan hjälpa till med.",
        },
        {
            src: "./images/rigging/rigging.png",
            heading: "PRIVATPERSON",
            description: "Bröllop, Studenten, 50-årsfirande, barnkalas eller gårdsfesten, klassfesten eller bara skapa lite mysigare känsla hemma. Vi har det du behöver!",
        },
    ];

    const [hoveredIndex, setHoveredIndex] = useState(null);
    const swiperRef = useRef(null);

    return (
        <div style={{ position: "relative" }}>
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                slidesPerView={4}
                slidesPerGroup={4}
                spaceBetween={40}
                autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true, // This pauses autoplay on hover
                }}
                loop={false}
                speed={1000}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                breakpoints={{
                    320: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 10,
                    },
                    640: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        spaceBetween: 40,
                    },
                }}
            >
                {images.map((item, index) => (
                    <SwiperSlide
                        key={index}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                        style={{ position: "relative" }}
                    >
                        <img
                            src={item.src}
                            alt={`Slide ${index + 1}`}
                            style={{ width: "100%", height: "auto", borderRadius: "15px", transform: "scale(0.9)", }}
                            className="home_slide_img"
                        />
                        <div
                            style={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                                right: "0",
                                bottom: "0",
                                textAlign: "center",
                                zIndex: 1,
                                
                            }}
                            className="text_outer"
                        >
                            <div className={`hover_text ${hoveredIndex === index ? "visible" : ""}`}>
                                <h3>{item.heading}</h3>
                                <p className={`description ${hoveredIndex === index ? "visible" : ""}`}>
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default ImageSlider;
